<div uid="discount-code-component" class="discountCode">
  @if (cart?.discount && hasBluetoothTherm) {
    <img
      class="image"
      src="https://www.datocms-assets.com/21281/1744186622-illustration-phone-therm.svg"
      alt="Natural Cyles App"
    />
  }

  @if (cart?.discount && !hasBluetoothTherm) {
    <img
      class="image"
      src="https://www.datocms-assets.com/21281/1744186622-illustration-phone-therm.svg"
      alt="Natural Cyles App"
    />
  }

  <div class="discountCode__content">
    @if (!cart?.discount) {
      <form class="codeInput" (submit)="submitCode($event)">
        <label>{{ 'code-title-enter' | translate }}</label>
        <input
          uid="discount-code-input"
          type="text"
          name="code"
          autofocus
          autocorrect="off"
          autocapitalize="none"
          autocomplete="off"
          [(ngModel)]="code"
        />
        <app-button
          uid="discount-code-submit-button"
          color="light-grey"
          text="purple"
          type="submit"
          label="{{ 'btn-continue' | translate }}"
          [disabled]="!code"
        />
      </form>
    }

    @if (cart?.discount) {
      <div uid="discount-code-items">
        <div class="headline">
          {{
            (cart?.discount?.code === 'referralid20' ? 'referral-code-discount' : 'exclusive-offer')
              | translate
          }}
        </div>
        @for (item of cart?.items; track item) {
          <app-cart-item
            [item]="item"
            [optional]="(cart?.discount?.optionalThermometer && !!item.hwId) || false"
            [selected]="includeTherm"
            (toggleSelected)="toggleTherm()"
            [showPrice]="item.type !== ProductType.OTHER"
            [nextRenewalProduct]="getNextRenewalProduct(item)"
          />
        }
        <div class="cart__divider"></div>
        <app-cart-price [cart]="cart!" />
        <app-button
          uid="discount-code-continue-button"
          color="light-grey"
          text="purple"
          label="{{ 'btn-start-my-journey' | translate }}"
          [ghost]="true"
          (click)="continue()"
        />
      </div>
    }
  </div>
</div>
